import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import FormField from "../components/FormField";
import Button from "../components/Button";
import Alert from "../components/Alert";
import { cerberus } from "../api/cerberus";
import { useSubmit } from "../lib/useSubmit";
import { isMfaRequired } from "../api/types";
import { completeLogin } from "../lib/session";
import { parseReturnTo } from "../lib/returnTo";

export default function Login(): JSX.Element {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const returnTo = parseReturnTo(search.toString());

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { busy, error, onSubmit } = useSubmit(async () => {
    const res = await cerberus.login({ email, password });
    if (isMfaRequired(res)) {
      navigate("/login/mfa", {
        state: {
          challenge_token: res.challenge_token,
          user_id: res.user_id,
          email: res.email,
          return_to: returnTo,
        },
      });
      return;
    }
    completeLogin(res, returnTo);
  }, "login failed");

  return (
    <AuthLayout
      title="Entrar"
      subtitle="Use seu email + senha"
      footer={
        <>
          <Link to={`/signup${returnTo ? `?return_to=${encodeURIComponent(returnTo)}` : ""}`}>
            Criar conta
          </Link>
          {" · "}
          <Link to="/forgot">Esqueci a senha</Link>
        </>
      }
    >
      {error ? <Alert variant="error">{error}</Alert> : null}
      <form onSubmit={onSubmit} noValidate>
        <FormField
          label="Email"
          name="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <FormField
          label="Senha"
          name="password"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button type="submit" disabled={busy}>
          {busy ? "Entrando..." : "Entrar"}
        </Button>
      </form>
    </AuthLayout>
  );
}
